import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfigService } from '@core/appconfig.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ViewerBaseComponent } from '../viewer-shared/viewer-base.component';
import { ViewerService } from '../viewer.service';

@Component({
  selector: 'zbp-viewer-document',
  templateUrl: './viewer-document.component.html',
  styleUrls: ['./viewer-document.component.scss',
    '../viewer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule]
})
export class ViewerDocumentComponent extends ViewerBaseComponent implements OnChanges {
  pdfJsUri: SafeResourceUrl = null;
  documentSource: string = '';
  @Input() locked: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private appConfigService: AppConfigService,
    private viewerService: ViewerService) {
    super();
  }

  ngOnChanges(): void {
    // Loads the pdf into a local blob, which increases our memory load in the browser, but it's the easiest way to
    // load cross-origin pdf content into pdf.js.
    // @todo refactor this once ViewerAssetJson is no more.
    this.documentSource = this.viewerService.getAssetFilenameUrl(this.asset, 'pdf', this.asset.language);
    this.viewerService.getMediaBlobUri(this.documentSource)
      .pipe(
        catchError((err) => {
          console.error(err);
          return of(null);
        })
      )
      .subscribe((uri) => {
        if (uri) {
          if (!this.locked) {
            this.pdfJsUri = this.sanitizer
              .bypassSecurityTrustResourceUrl(`${this.appConfigService.pdfViewerUrl}?file=${uri}`);
          } else {
            this.pdfJsUri = this.sanitizer
              .bypassSecurityTrustResourceUrl(`${this.appConfigService.pdfViewerLockedUrl}?file=${uri}`);
          }
          this.loaded.emit();
        } else {
          this.withError.emit('Unable to load this resource');
        }
      });
  }
}
